import { GroupBase, StylesConfig } from "react-select";

const MENU_PORTAL_Z_INDEX_ABOVE_MODAL = 1100;

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const SELECT_STYLES: StylesConfig<any, any, GroupBase<any>> = {
  placeholder: (provided) => ({
    ...provided,
    color: "var(--g-color-text-hint)",
  }),

  control: (provided) => ({
    ...provided,
    borderRadius: "var(--g-border-radius-s)",
    border: "1px solid var(--g-color-line-generic)",
    borderColor: "var(--g-color-line-generic)",
    backgroundColor: "transparent",
    boxShadow: "none",
    minHeight: 28,
    cursor: "pointer",
    "&:hover": {
      borderColor: "var(--g-color-line-generic)",
      boxShadow: "none",
      backgroundColor: "var(--g-color-base-simple-hover)",
    },
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    backgroundColor:
      isFocused || isSelected
        ? "var(--g-color-base-simple-hover)"
        : "transparent",
    color: "unset",
    margin: "0px",
    cursor: "pointer",
  }),

  singleValue: (provided) => ({
    ...provided,
    color: "var(--g-color-text-primary)",
  }),

  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "var(--g-color-base-generic)",
  }),

  multiValueLabel: (provider) => ({
    ...provider,
    color: "var(--g-color-text-primary)",
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: "0 6px",
  }),

  input: (provided) => ({
    ...provided,
    color: "var(--g-color-text-primary)",
    margin: "0px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: 26,
  }),
  menu: (provider) => ({
    ...provider,
    zIndex: 2,
    backgroundColor: "var(--g-color-base-float)",
  }),
  menuPortal: (provider) => ({
    ...provider,
    zIndex: MENU_PORTAL_Z_INDEX_ABOVE_MODAL,
  }),
  container: (provider) => ({
    ...provider,
    width: "100%",
  }),
};

// Максимальная высота контейнера с выбранными чипами; дальше — внутренний скролл,
// чтобы много выбранных категорий не растягивали контрол на пол-экрана.
const CHIPS_MAX_HEIGHT = 108;

// Дерево категорий — общие стили контрола и списка. Боковое (вправо)
// позиционирование выпадающего меню на десктопе делает CategoryMenuPortal.
export const CATEGORY_SELECT_STYLES: StylesConfig<any, any, GroupBase<any>> = {
  ...SELECT_STYLES,
  valueContainer: (provided, state) => ({
    ...(SELECT_STYLES.valueContainer?.(provided, state) ?? provided),
    maxHeight: CHIPS_MAX_HEIGHT,
    overflowY: "auto",
  }),
  menuList: (provided, state) => ({
    ...(SELECT_STYLES.menuList?.(provided, state) ?? provided),
    maxHeight: "min(460px, 65vh)",
  }),
};
